module.exports = __webpack_public_path__ + "static/2018_2-d9d9daf737176b72ec27fda4f48abfeb.jpg";